/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_BAND_ROUTE } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IBandRouteMethods extends IPluginMethodMap {
  getBandRouteProps(args: any): Promise<any>;
}

export class BandRouteService implements IAgentPlugin {
  readonly methods: IBandRouteMethods;

  constructor() {
    this.methods = {
      getBandRouteProps: this.getBandRouteProps.bind(this),
    };
  }

  async getBandRouteProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("argsargsargs36", args);
    try {
      if (client) {
        const res = await client.query({
          query: GET_BAND_ROUTE,
          variables: {
            filter: { ...args },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          return {
            response: res,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
